export default __webpack_public_path__ + "static/media/Logo.1ce7aa4c.png";